import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';

import color from '@decisiv/design-tokens/lib/color';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import { FlexProps } from '@decisiv/ui-components';

export const BorderlessInput = styled.input`
  display: inline-block;
  border: none;
  outline: none;
`;

interface TagContainerProps extends FlexProps {
  disabled?: boolean;
}

export const TagContainer = styled(Flex).attrs({
  flex: 1,
  flexWrap: 'wrap',
  flexDirection: 'column',
  paddingLeft: 1,
  paddingY: 0.5,
})<TagContainerProps>`
  width: 100%;
  border: 1px solid ${toColorString(color.base.quarterMoon)};
  background-color: ${({ disabled }) =>
    disabled
      ? toColorString(color.opacity.fullMoon50)
      : toColorString(color.base.snowWhite)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};

  input {
    background-color: inherit;
    cursor: inherit;
  }
`;

export const TagInputContainer = styled(Flex).attrs({
  flex: 1,
  alignItems: 'center',
  flexWrap: 'wrap',
})`
  gap: 5px;
` as typeof Flex;

interface CustomWidthFlexProps extends FlexProps {
  width: string;
}

export const CustomWidthFlex = styled(Flex)<CustomWidthFlexProps>`
  width: ${(props) => props.width};
`;
